module.exports = __webpack_public_path__ + "media/entities/1108-09271850.png";